import script from "./UserEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditModal.vue?vue&type=script&setup=true&lang=js"

import "./UserEditModal.vue?vue&type=style&index=0&id=6b8dae1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8dae1c"]])

export default __exports__